function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, TextField, Card, CardContent } from '@mui/material';
import FeedbackLogo from '../../../public/FeedbackLogo.svg';
import IdeaIcon from '../../../public/enhancement.svg';
import RepairIcon from '../../../public/issue.svg';
import IdeaGif from '../../../public/enhancement.gif';
import RepairGif from '../../../public/issue.gif';
import BallotBoxGif from '../../../public/ballot-box.gif';
import SuccessModal from '../SuccessModal';
import FilePicker from '../FilePicker';
import { FeedbackAPI } from '../../apis/FeedbackAPI';
import Cookies from 'js-cookie';
import { useTheme } from '@mui/material/styles';
import '../../types/theme'; // Import theme type extensions
import './FeedbackModal.css';
import { constants } from '../../constants';
import { ConfigContext } from '../ConfigContext';
import { useCurrentApplication } from '../ApplicationContext';
import { getDefaultApplication, getEmailFromSession, getUserFromCookie, isGenericGreenColor } from '@/utils/utilities';
import Sound from '../Sound/Sound';
import { checkProfanity } from '@/utils/profanityCheckUtils';
import ErrorModal from '../ErrorModal';
var FeedbackTypeCard = function FeedbackTypeCard(_ref) {
    var type = _ref.type, title = _ref.title, description = _ref.description, icon = _ref.icon, gif = _ref.gif, isSelected = _ref.isSelected, onClick = _ref.onClick;
    var theme = useTheme();
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState;
    React.useEffect(function () {
        var _configState$settings, _configState$settings2, _configState$settings3, _configState$settings4, _configState$settings5;
        var cssVars = {
            '--gradient-background': isGenericGreenColor(configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.button_color) ? 'linear-gradient(180deg, #1BA4DE 0%, #3EBC32 100%)' : configState === null || configState === void 0 || (_configState$settings2 = configState.settings) === null || _configState$settings2 === void 0 ? void 0 : _configState$settings2.button_color,
            '--text-color': (configState === null || configState === void 0 || (_configState$settings3 = configState.settings) === null || _configState$settings3 === void 0 ? void 0 : _configState$settings3.workspace_name_color) || theme.palette.text.primary,
            '--button-bg-color': (configState === null || configState === void 0 || (_configState$settings4 = configState.settings) === null || _configState$settings4 === void 0 ? void 0 : _configState$settings4.button_color) || theme.palette.primary.dark,
            '--button-text-color': (configState === null || configState === void 0 || (_configState$settings5 = configState.settings) === null || _configState$settings5 === void 0 ? void 0 : _configState$settings5.button_text_color) || theme.palette.primary.contrastText
        };
        for (var _i = 0, _Object$entries = Object.entries(cssVars); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
            document.documentElement.style.setProperty(key, value);
        }
    }, [configState]);
    return /*#__PURE__*/ React.createElement(Card, {
        className: "feedback-type-card ".concat(isSelected ? 'selected' : ''),
        onClick: onClick,
        "data-testid": "feedback-type-".concat(type)
    }, /*#__PURE__*/ React.createElement(CardContent, {
        className: "feedback-card-content"
    }, /*#__PURE__*/ React.createElement(Box, {
        className: "feedback-card-header"
    }, /*#__PURE__*/ React.createElement(Box, {
        p: '4px',
        className: "feedback-card-icon ".concat(isSelected ? 'selected' : '')
    }, isSelected ? /*#__PURE__*/ React.createElement("img", {
        src: gif,
        alt: type,
        width: 24,
        height: 24
    }) : /*#__PURE__*/ React.createElement("img", {
        src: icon,
        alt: type
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        fontWeight: 600,
        className: "feedback-card-title"
    }, title), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        className: "feedback-card-description"
    }, description))));
};
var FeedbackModal = function FeedbackModal(_ref2) {
    var open = _ref2.open, onClose = _ref2.onClose, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? '800px' : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? 'auto' : _ref2$height;
    var _useState = useState('enhancement'), _useState2 = _slicedToArray(_useState, 2), selectedType = _useState2[0], setSelectedType = _useState2[1];
    var _useState3 = useState(''), _useState4 = _slicedToArray(_useState3, 2), description = _useState4[0], setDescription = _useState4[1];
    var _useState5 = useState(false), _useState6 = _slicedToArray(_useState5, 2), successModalOpen = _useState6[0], setSuccessModalOpen = _useState6[1];
    var _useState7 = useState(false), _useState8 = _slicedToArray(_useState7, 2), errorModalOpen = _useState8[0], setErrorModalOpen = _useState8[1];
    var _useState9 = useState(''), _useState0 = _slicedToArray(_useState9, 2), ticketNumber = _useState0[0], setTicketNumber = _useState0[1];
    var _useState1 = useState([]), _useState10 = _slicedToArray(_useState1, 2), attachedFiles = _useState10[0], setAttachedFiles = _useState10[1];
    var _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), isSubmitting = _useState12[0], setIsSubmitting = _useState12[1];
    var _useState13 = useState(true), _useState14 = _slicedToArray(_useState13, 2), isValidFiles = _useState14[0], setIsValidFiles = _useState14[1];
    var _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), play = _useState16[0], setPlay = _useState16[1];
    var _useState17 = useState('success'), _useState18 = _slicedToArray(_useState17, 2), type = _useState18[0], setType = _useState18[1];
    var _useState19 = useState(false), _useState20 = _slicedToArray(_useState19, 2), hasProfanity = _useState20[0], setHasProfanity = _useState20[1];
    var productId = Cookies.get('Product Selected');
    var currentApp = useCurrentApplication(productId ? Number(productId) : 0);
    var appDetails = sessionStorage.getItem('current_application') ? JSON.parse(sessionStorage.getItem('current_application') || '{}') : currentApp;
    var MAX_CHARS = 1000;
    var remainingChars = MAX_CHARS - description.length;
    React.useEffect(function () {
        if (!open) {
            setIsSubmitting(false);
            setIsValidFiles(true);
            setHasProfanity(false);
        }
    }, [open]);
    var processFileToBase64 = function processFileToBase64(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                var result = reader.result;
                var base64 = result.split(',')[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    var processAttachments = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(files) {
            var attachments;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return Promise.all(files.map(/*#__PURE__*/ function () {
                                var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(file) {
                                    var base64Content;
                                    return _regenerator().w(function (_context) {
                                        while (1)
                                            switch (_context.n) {
                                                case 0:
                                                    _context.n = 1;
                                                    return processFileToBase64(file);
                                                case 1:
                                                    base64Content = _context.v;
                                                    return _context.a(2, {
                                                        contentType: file.type,
                                                        content: base64Content
                                                    });
                                            }
                                    }, _callee);
                                }));
                                return function (_x2) {
                                    return _ref4.apply(this, arguments);
                                };
                            }()));
                        case 1:
                            attachments = _context2.v;
                            return _context2.a(2, attachments);
                    }
            }, _callee2);
        }));
        return function processAttachments(_x) {
            return _ref3.apply(this, arguments);
        };
    }();
    var handleSubmit = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var defaultApp, attachments, user, feedbackRequest, data, githubIssueId, _error$backendRespons, _t;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (!(!description.trim() || description.length > MAX_CHARS || isSubmitting || hasProfanity)) {
                                _context3.n = 1;
                                break;
                            }
                            return _context3.a(2);
                        case 1:
                            setIsSubmitting(true);
                            _context3.p = 2;
                            defaultApp = getDefaultApplication();
                            _context3.n = 3;
                            return processAttachments(attachedFiles);
                        case 3:
                            attachments = _context3.v;
                            user = getUserFromCookie();
                            feedbackRequest = {
                                resourceType: 'feedback',
                                type: selectedType,
                                title: "[".concat(selectedType.toUpperCase(), "] ").concat((appDetails === null || appDetails === void 0 ? void 0 : appDetails.id) || defaultApp.appName),
                                source: {
                                    source_url: "".concat(globalThis.window.location.href),
                                    application_name: (appDetails === null || appDetails === void 0 ? void 0 : appDetails.name) || defaultApp.appName,
                                    application_id: String((appDetails === null || appDetails === void 0 ? void 0 : appDetails.id) || defaultApp.appId)
                                },
                                description: description,
                                attachment: attachments,
                                submittedBy: {
                                    name: user.name,
                                    email: user.email
                                },
                                meta: {}
                            };
                            _context3.n = 4;
                            return FeedbackAPI.submitFeedback(feedbackRequest);
                        case 4:
                            data = _context3.v;
                            if (data) {
                                githubIssueId = data === null || data === void 0 ? void 0 : data.id;
                                setTicketNumber(githubIssueId);
                                setSuccessModalOpen(true);
                                setType('success');
                                setPlay(true);
                                onClose();
                            }
                            _context3.n = 6;
                            break;
                        case 5:
                            _context3.p = 5;
                            _t = _context3.v;
                            // Log comprehensive backend error information
                            console.error('Error submitting feedback:', {
                                message: _t.message,
                                backendResponse: _t.backendResponse,
                                statusCode: _t.statusCode,
                                fullError: _t
                            });
                            if ((_error$backendRespons = _t.backendResponse) !== null && _error$backendRespons !== void 0 && (_error$backendRespons = _error$backendRespons.errors) !== null && _error$backendRespons !== void 0 && (_error$backendRespons = _error$backendRespons.description) !== null && _error$backendRespons !== void 0 && _error$backendRespons.includes('profanity')) {
                                setHasProfanity(true);
                            }
                            setType('error');
                            setPlay(true);
                            setErrorModalOpen(true);
                            onClose();
                        case 6:
                            _context3.p = 6;
                            setIsSubmitting(false);
                            setDescription('');
                            setAttachedFiles([]);
                            setSelectedType('enhancement');
                            return _context3.f(6);
                        case 7:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[2, 5, 6, 7]]);
        }));
        return function handleSubmit() {
            return _ref5.apply(this, arguments);
        };
    }();
    var handleSuccessModalClose = function handleSuccessModalClose() {
        setSuccessModalOpen(false);
        setSelectedType('enhancement');
        setDescription('');
        setTicketNumber('');
        setAttachedFiles([]);
        setIsSubmitting(false);
        setHasProfanity(false);
    };
    var handleDescriptionChange = function handleDescriptionChange(event) {
        var value = event.target.value;
        setDescription(value);
        setHasProfanity(checkProfanity(value));
    };
    var handleCancelFeedback = function handleCancelFeedback() {
        onClose();
        setSelectedType('enhancement');
        setDescription('');
        setAttachedFiles([]);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        keepMounted: attachedFiles.length > 0,
        maxWidth: "md",
        fullWidth: true,
        "aria-labelledby": "feedback-modal-title",
        "data-testid": "feedback-modal",
        PaperProps: {
            sx: {
                borderRadius: '24px',
                width: width,
                height: height
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        id: "feedback-modal-title",
        className: "feedback-modal-title"
    }, /*#__PURE__*/ React.createElement("img", {
        src: FeedbackLogo,
        alt: "Feedback"
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        component: "div"
    }, constants.feedback)), /*#__PURE__*/ React.createElement(DialogContent, {
        className: "feedback-modal-content"
    }, /*#__PURE__*/ React.createElement(Box, {
        className: "feedback-cards-container"
    }, /*#__PURE__*/ React.createElement(FeedbackTypeCard, {
        type: "enhancement",
        title: constants.enhancement_title,
        description: constants.enhancement_desc,
        icon: IdeaIcon,
        gif: IdeaGif,
        isSelected: selectedType === 'enhancement',
        onClick: function onClick() {
            return setSelectedType('enhancement');
        }
    }), /*#__PURE__*/ React.createElement(FeedbackTypeCard, {
        type: "issue",
        title: constants.issue_title,
        description: constants.issue_desc,
        icon: RepairIcon,
        gif: RepairGif,
        isSelected: selectedType === 'issue',
        onClick: function onClick() {
            return setSelectedType('issue');
        }
    })), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(TextField, {
        multiline: true,
        rows: 4,
        label: selectedType === 'issue' ? constants.issue_description_placeholder : constants.suggestion_description_placeholder,
        value: description,
        onChange: function onChange(e) {
            return handleDescriptionChange(e);
        },
        required: true,
        "data-testid": "feedback-description",
        variant: "outlined",
        error: remainingChars < 0,
        className: "feedback-textarea ".concat(remainingChars < 0 ? 'error' : '')
    }), /*#__PURE__*/ React.createElement(Box, {
        className: "feedback-char-count"
    }, hasProfanity ? /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        color: "error"
    }, constants.feedback_profanity_error) : /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        color: remainingChars < 0 ? 'error' : 'text.secondary'
    }, remainingChars >= 0 ? constants.max_1000_chars : /*#__PURE__*/ React.createElement(React.Fragment, null, "\uD83D\uDD34 ", constants.reached_max_limit)), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption",
        color: remainingChars < 0 ? 'error' : 'text.secondary'
    }, description.length, "/1000"))), /*#__PURE__*/ React.createElement(Box, {
        className: "feedback-attachment-section"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "subtitle2",
        className: "feedback-attachment-title"
    }, constants.attachment_label), /*#__PURE__*/ React.createElement(FilePicker, {
        onFilesChange: function onFilesChange(files, validity) {
            setAttachedFiles(files);
            setIsValidFiles(validity);
        },
        maxTotalSize: 10 * 1024 * 1024 // 10MB
        ,
        acceptedTypes: ['.png', '.jpg', '.txt'],
        multiple: true
    }))), /*#__PURE__*/ React.createElement(DialogActions, {
        className: "feedback-modal-actions"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleCancelFeedback,
        variant: "text",
        "data-testid": "feedback-cancel-button",
        className: "feedback-cancel-button"
    }, constants.cancel), description.trim() && isValidFiles && /*#__PURE__*/ React.createElement(Button, {
        onClick: handleSubmit,
        variant: "contained",
        color: "success",
        disabled: isSubmitting || description.length > MAX_CHARS || hasProfanity,
        "data-testid": "feedback-submit-button",
        className: "feedback-submit-button"
    }, isSubmitting ? constants.submitting : constants.submit))), /*#__PURE__*/ React.createElement(SuccessModal, {
        open: successModalOpen,
        onClose: handleSuccessModalClose,
        title: constants.success_title,
        message: /*#__PURE__*/ React.createElement("span", null, constants.ticket_number + ' ', /*#__PURE__*/ React.createElement("strong", null, ticketNumber), ' ' + constants.for_reference),
        buttonText: constants.close,
        gif: BallotBoxGif
    }), /*#__PURE__*/ React.createElement(ErrorModal, {
        open: errorModalOpen,
        onClose: function onClose() {
            return setErrorModalOpen(false);
        },
        title: constants.feedback_error_modal_title,
        description: hasProfanity ? constants.feedback_error_modal_profanity_description : constants.feedback_error_modal_description(getEmailFromSession())
    }), /*#__PURE__*/ React.createElement(Sound, {
        type: type,
        play: play,
        setPlay: setPlay
    }));
};
export default FeedbackModal;
